import React, {Component} from "react"
import {connect} from "react-redux"
import ErrorAlert from "../components/ErrorAlert"
import Alert from "../components/Alert"

function mapStateToProps(state, ownProps) {

  const user = state.user
  return {
    user
  }
}

const mapDispatchToProps = {

}

class AccessDeniedView extends Component {

  constructor(data){
    super(data)
    this.state={

    }
  }



  render() {

    return (
      <div>
        <Alert show={true} message={"Your user account is not setup properly. Please sign out and contact portal admin."}/>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccessDeniedView)



// WEBPACK FOOTER //
// ./src/routes/AccessDeniedView.js